/** 青山科技奖指南 */
import React from 'react';

export default function article() {
  return (
    <div className="guide-wrap-qs">
      <div className="sx-title">一、申报条件</div>
      <div className="sx-content">1．申报时间：2026年4月10日-2026年7月26日。</div>
      <div className="sx-content">2．申报人应是1981年1月1日（含）后出生，在中国内地及港澳地区全职工作的青年科研工作者。</div>
      <div className="sx-content">3．由奖项邀请的提名人发起提名，或由两位以上正高级职称（教授、研究员、教授级高工等）同行专家推荐，每位专家限提名/推荐一人。</div>
      <div className="sx-content">4．申报人主要在材料科学、化学、化学工程、环境科学、能源科学等学科或相关交叉领域开展研究，聚焦绿色低碳材料、碳捕集及资源化利用、新能源及储能、降碳减污协同控制四大议题，交叉领域特别鼓励数智技术在上述议题的创新应用。</div>
      <div className="sx-content">释义：</div>
      <div className="sx-content">绿色低碳材料：主要包括生物基材料、循环再生材料、材料的绿色低碳制造等方向的科学研究和技术突破。</div>
      <div className="sx-content">碳捕集及资源化利用：主要包括碳捕集和分离、二氧化碳资源化利用等方向的科学研究和技术突破。</div>
      <div className="sx-content">新能源及储能：主要包括光伏、生物质能、氢能等新能源方向，以及化学储能、电化学储能等储能方向的科学研究和技术突破。</div>
      <div className="sx-content">降碳减污协同控制：统筹温室气体减排与水、气、土、固废等领域污染治理协同控制，实现二者协同增效的科学研究和技术突破。</div>
      <div className="sx-content">5． 提交资料不应涉及军工或与国家安全相关项目内容。</div>
      <div className="sx-title">二、申报流程</div>
      <div className="sx-content">1．申报人应在2026年7月26日24时前登录美团青山科技基金官网（https://greentech.meituan.com）按说明完成申报。</div>
      <div className="sx-content">2．同行专家推荐书应于2026年7月31日24时前上传至申报系统。</div>
      <div className="sx-title">三、申报内容</div>
      <div className="sx-content">1．基本信息：包括教育经历、科研工作经历等；</div>
      <div className="sx-content">2．科研信息：所属学科领域、科研议题、代表性学术成果等。其中代表性论文建议填写申报人近5年作为一作或通讯作者发表的论文。</div>
      <div className="sx-content">3．申报信息：包括提名码/推荐信、申报书等。申报书内容包括研究工作对所申报青山科技奖议题的贡献和价值、科研及学术成就、在研科研项目及学术进展、未来科研工作规划。</div>
      <div className="sx-title">四、青山科技奖不收取任何费用，奖项的申请、评审和授奖，严格遵循公平、公正、公开的原则，杜绝任何组织或个人超越章程的干涉评奖过程行为。</div>
      <div className="sx-title text-r">青山科技奖秘书处</div>
      <div className="sx-title text-r">2026年4月</div>
    </div>
  );
}
